import React, { useState } from 'react';

const CustomTab:React.FC<TabsProps> = ({tabs}) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index: number) => {
    setActiveTab(index);
  };

  return (
    <div className='tab_wrapper'>
      <div className="tab_header">
        {tabs?.map((tab, index) => (
          <div
            key={index}
            className={`tab_item ${index === activeTab ? 'active' : 'inherit'}`}
            onClick={() => handleTabClick(index)}
          >
            {tab.title}
          </div>
        ))}
      </div>
      <div className="tab_content">
        {tabs[activeTab]?.content}
      </div>
    </div>
  );
};

export default CustomTab;
